import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ServicesService } from 'src/services/services.service';

interface HospitalService {
  name: string;
  image: string;
  description: string;
}

@Component({
  selector: 'app-view-service-detail',
  templateUrl: './view-service-detail.component.html',
  styleUrls: ['./view-service-detail.component.scss']
})
export class ViewServiceDetailComponent implements OnInit {

  hospital: any = {
    id: '',
    name: '',
    doctor: '',
    address: '',
    phone: '',
    website: '',
    notes: '',
    image: '',
    services: []
  };

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private service: ServicesService
  ) { }

  ngOnInit(): void {

    const so_id = this.route.snapshot.paramMap.get('id');

    if (so_id) {
      this.getHospitalDetails(so_id);
      this.getProducts(so_id);
    }

  }

  getHospitalDetails(so_id: any) {

    this.service.get_stall_owner_by_id(so_id).subscribe(
      (res: any) => {

        console.log(res);

        // If API returns array
        const data = Array.isArray(res.data) ? res.data[0] : res.data;

        this.hospital = {
          id: data.so_id,
          name: data.company_name,
          doctor: data.owner_name,
          address: data.address,
          phone: data.owner_number,
          website: data.website,
          notes: data.notes || 'No notes available.',
          image: data.image_path
            ? data.image_path
            : 'assets/images/hospital.png',
        },
          (error: any) => {
            console.error(error);
          }
      }
    );

  }

  getProducts(so_id: any) {

    this.service.getProductsForStall(so_id).subscribe(
      (res: any) => {


        const products = Array.isArray(res.data) ? res.data : (res.data || []);
        console.log('Products', products);

        this.hospital.services = products.map((item: any) => ({
          name: item.product_title,
          description: item.description || '',
          image: item.image_path || '',
          // icon: this.getServiceIcon(item.product_name)
        }));

      },
      error => {
        console.error(error);
      }
    );

  }

  goBack() {
    this.location.back();
  }

}